const routes = {
  root: "/",
  login: "/",
  conversations: "/conversations",
  settings: "/settings",
  profile: "/settings/profile",
  themes: "/settings/themes",
};

export default routes;
